import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "action-list" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "dialog-footer" }
const _hoisted_14 = { class: "action-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectBrand = _resolveComponent("SelectBrand")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SelectBrand, {
        ifBody: 0,
        onBrandChange: _ctx.onBrandChange
      }, null, 8, ["onBrandChange"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: _ctx.filters.check_start_date,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.check_start_date) = $event)),
        type: "date",
        placeholder: "审核开始日期",
        "value-format": "YYYY-MM-DD",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _cache[28] || (_cache[28] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: _ctx.filters.check_end_date,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.check_end_date) = $event)),
        type: "date",
        placeholder: "审核结束日期",
        "value-format": "YYYY-MM-DD",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: _ctx.filters.start_date,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.start_date) = $event)),
        type: "date",
        placeholder: "制单开始日期",
        "value-format": "YYYY-MM-DD",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _cache[29] || (_cache[29] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: _ctx.filters.end_date,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.end_date) = $event)),
        type: "date",
        placeholder: "制单结束日期",
        "value-format": "YYYY-MM-DD",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.title,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.title) = $event)),
        placeholder: "请输入商品名称",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: _ctx.filters.status,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.status) = $event)),
        placeholder: "审核状态",
        style: {"width":"170px"},
        disabled: _ctx.checkStatusDisabled,
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: ""
          }),
          _createVNode(_component_el_option, {
            label: "待审核",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "审核通过",
            value: 2
          }),
          _createVNode(_component_el_option, {
            label: "驳回",
            value: 3
          })
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.second_brand_name,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.second_brand_name) = $event)),
        placeholder: "请输入二级品牌",
        clearable: "",
        style: {"width":"170px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.admin_name,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.admin_name) = $event)),
        placeholder: "制单人",
        clearable: "",
        style: {"width":"170px"}
      }, null, 8, ["modelValue"]),
      (_ctx.groupList.includes('69') || _ctx.groupList.includes('77'))
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            class: "filter-item",
            modelValue: _ctx.filters.is_yy_check,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.is_yy_check) = $event)),
            placeholder: "审核部门"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                value: 1,
                label: "运营部"
              }),
              _createVNode(_component_el_option, {
                value: 0,
                label: "客服部"
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSearch()))
      }, {
        default: _withCtx(() => _cache[25] || (_cache[25] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onExport()))
      }, {
        default: _withCtx(() => _cache[26] || (_cache[26] = [
          _createTextVNode("规格导出")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onProductExport()))
      }, {
        default: _withCtx(() => _cache[27] || (_cache[27] = [
          _createTextVNode("商品导出")
        ])),
        _: 1
      }),
      _createVNode(_component_el_checkbox, {
        modelValue: _ctx.filters.is_new,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters.is_new) = $event)),
        "true-value": 1,
        "false-value": 0,
        label: "新商品（待审核）",
        size: "large",
        onChange: _ctx.isNewChange
      }, null, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_checkbox, {
        modelValue: _ctx.filters.is_new,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filters.is_new) = $event)),
        "true-value": 2,
        "false-value": 0,
        label: "旧商品（待审核）",
        size: "large",
        onChange: _ctx.isNewChange
      }, null, 8, ["modelValue", "onChange"])
    ]),
    _createVNode(_component_el_dropdown, { style: {"margin-bottom":"10px"} }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_dropdown_item, {
              type: "primary",
              size: "small",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.toCheck(1)))
            }, {
              default: _withCtx(() => _cache[31] || (_cache[31] = [
                _createTextVNode("批量通过并上架")
              ])),
              _: 1
            }),
            _createVNode(_component_el_dropdown_item, {
              type: "primary",
              size: "small",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.openDialog()))
            }, {
              default: _withCtx(() => _cache[32] || (_cache[32] = [
                _createTextVNode("批量通过并下架")
              ])),
              _: 1
            }),
            _createVNode(_component_el_dropdown_item, {
              type: "primary",
              size: "small",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.rejectDialog = true))
            }, {
              default: _withCtx(() => _cache[33] || (_cache[33] = [
                _createTextVNode("批量驳回")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small"
        }, {
          default: _withCtx(() => _cache[30] || (_cache[30] = [
            _createTextVNode(" 批量操作 "),
            _createElementVNode("i", { class: "el-icon-arrow-down" }, null, -1)
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_table, {
      data: _ctx.tableData,
      border: "",
      onSelectionChange: _ctx.onSelectionChange,
      "row-key": "id"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          selectable: _ctx.selectable,
          title: "审核过的商品不可再次审核",
          width: "55"
        }, null, 8, ["selectable"]),
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "brand_shop_discount",
          label: "品牌折扣"
        }),
        _createVNode(_component_el_table_column, {
          prop: "p_id",
          label: "商品ID"
        }, {
          default: _withCtx((scope) => [
            (scope.row.p_id == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "--"))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(scope.row.p_id), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "商品"
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "规格"
        }, {
          default: _withCtx((scope) => [
            (scope.row.specs_list.length <= 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.specs_list, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (!scope.row.showAll)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.specs_list.slice(0, 3), (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                        }), 128)),
                        _createElementVNode("span", {
                          style: {"color":"blue"},
                          onClick: ($event: any) => (_ctx.toggleShowAll(scope.row))
                        }, "展开", 8, _hoisted_8)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.specs_list, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                        }), 128)),
                        _createElementVNode("span", {
                          style: {"color":"blue"},
                          onClick: ($event: any) => (_ctx.toggleShowAll(scope.row))
                        }, "收起", 8, _hoisted_10)
                      ]))
                ]))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "market_price",
          label: "市场价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "price",
          label: "售价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "审核状态",
          width: "90"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.OCheckStatus[scope.row.status]==='审核通过' ? scope.row.is_voluntarily && (new Date().getTime() < new Date(scope.row.voluntarily_time).getTime()) ? '定时审核，待执行' : '审核通过' : _ctx.OCheckStatus[scope.row.status]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "审核时间",
          width: "160"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.check_time === '0000-00-00 00:00:00' ? '' : scope.row.check_time), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "add_time",
          label: "制单时间",
          width: "160"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: _ctx.filters.is_yy_check === 1 && (_ctx.groupList.includes('69') || _ctx.groupList.includes('77')) ? '150' : '100'
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: ($event: any) => (_ctx.toEdit(scope.row, 'check')),
                size: "small"
              }, {
                default: _withCtx(() => _cache[34] || (_cache[34] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              (_ctx.OCheckStatus[scope.row.status]==='待审核' && _ctx.filters.is_yy_check === 1 && (_ctx.groupList.includes('69') || _ctx.groupList.includes('77')))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    onClick: ($event: any) => (_ctx.toCustomer(scope.row)),
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[35] || (_cache[35] = [
                      _createTextVNode("转客服")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (scope.row.jingjia_info.length > 0 && _ctx.filters.is_yy_check === 1 && (_ctx.groupList.includes('69') || _ctx.groupList.includes('77')))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "color-primary",
                    onClick: ($event: any) => (_ctx.toProduct(scope.row)),
                    style: {"margin-top":"10px"}
                  }, "查看相似商品", 8, _hoisted_12))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["width"])
      ]),
      _: 1
    }, 8, ["data", "onSelectionChange"]),
    _createVNode(_component_Pagination, {
      currentPage: _ctx.filters.page,
      total: _ctx.total,
      onPageChange: _ctx.onPageChange,
      onSizeChange: _ctx.onSizeChange
    }, null, 8, ["currentPage", "total", "onPageChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "下架原因",
      modelValue: _ctx.productShelfShow,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.productShelfShow) = $event)),
      "before-close": _ctx.onProductShelfShow
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_13, [
          _createVNode(_component_el_button, { onClick: _ctx.onProductShelfShow }, {
            default: _withCtx(() => _cache[36] || (_cache[36] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.toCheck(2)))
          }, {
            default: _withCtx(() => _cache[37] || (_cache[37] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.shelf,
          "label-width": "120px",
          ref: "shelfProductForm",
          rules: _ctx.shelfRule
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "下架类型",
              prop: "soldout_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"300px"},
                  filterable: "",
                  modelValue: _ctx.shelf.soldout_type,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.shelf.soldout_type) = $event)),
                  placeholder: "下架类型",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['商品溢价'],
                      label: "商品溢价"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['折扣不合格'],
                      label: "折扣不合格"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['信息有误'],
                      label: "信息有误"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['质量问题'],
                      label: "质量问题"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['口感不佳'],
                      label: "口感不佳"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['整改下架'],
                      label: "整改下架"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['永久下架'],
                      label: "永久下架"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "下架原因" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: _ctx.shelf.soldout_reson,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.shelf.soldout_reson) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "下架原因",
                  maxlength: "100",
                  rows: 4,
                  "show-word-limit": "",
                  style: {"width":"400px"},
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "驳回原因",
      modelValue: _ctx.rejectDialog,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.rejectDialog) = $event)),
      "before-close": _ctx.onRejectDialogClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "info",
          plain: "",
          onClick: _ctx.onRejectDialogClose
        }, {
          default: _withCtx(() => _cache[38] || (_cache[38] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.toCheck(3)))
        }, {
          default: _withCtx(() => _cache[39] || (_cache[39] = [
            _createTextVNode("驳 回")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_input, {
            type: "textarea",
            modelValue: _ctx.check_msg,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.check_msg) = $event)),
            modelModifiers: { trim: true },
            maxlength: "100",
            rows: 4,
            "show-word-limit": "",
            placeholder: "请输入驳回原因"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "竞价相似商品",
      modelValue: _ctx.productSubmissionShow,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.productSubmissionShow) = $event)),
      "before-close": _ctx.onproductSubmissionShow
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _ctx.productSubmissioData,
          border: "",
          "row-key": "id",
          "max-height": "500",
          class: "product-table"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { type: "index" }),
            _createVNode(_component_el_table_column, {
              prop: "brand_name",
              label: "品牌名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "商品ID"
            }),
            _createVNode(_component_el_table_column, {
              prop: "title",
              label: "商品名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "规格名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "clearing_price",
              label: "结算价"
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              label: "当前商品状态"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(scope.row.status === 1 ? '上架' : '下架'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "deleted",
              label: "当前规格状态"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(scope.row.deleted === 0 ? '上架' : '下架'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              fixed: "right",
              width: "110px"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_14, [
                  (scope.row.id && scope.row.status === 1 && scope.row.deleted == 0)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        title: scope.row.stock == 0 ? '库存为0，不可操作上架' : '',
                        class: "mt8",
                        type: "primary",
                        size: "small",
                        onClick: _withModifiers(($event: any) => (_ctx.updateSpecStatus(scope.row)), ["prevent"])
                      }, {
                        default: _withCtx(() => _cache[40] || (_cache[40] = [
                          _createTextVNode("下架该规格")
                        ])),
                        _: 2
                      }, 1032, ["title", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ]))
}